<template lang="pug">
  span
    span(v-html="abbreviatedText")
    a(@click="open" v-if="abbreviated") ...more
</template>

<script>
  export default {
    props: ['text'],
    data () {
      const abbreviated = this.text && this.text.length > 100
      return {
        abbreviated,
        abbreviatedText: abbreviated ? this.text.slice(0, 100) : this.text,
      }
    },
    watch: {
      text () {
        this.abbreviated = this.text && this.text.length > 100
        this.updateAbbreviatedText()
      },
      abbreviated () {
        this.updateAbbreviatedText()
      },
    },
    methods: {
      open () {
        this.abbreviated = false
      },
      updateAbbreviatedText () {
        this.abbreviatedText = this.abbreviated ? this.text.slice(0, 100) : this.text
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/AbbreviationText.vue